export const TYPES = {
  DEFAULT: 'default',
  NAV_CART: 'nav-cart',
  UPSELL_HEADER: 'upsell-header',
};
